export enum QuotationErrorOrigin {
    CREATE_QUOTATION = 'CREATE_QUOTATION',
    GET_QUOTATION_FILE = 'GET_QUOTATION_FILE',
    GET_QUOTATIONS = 'GET_QUOTATIONS',
    GET_QUOTATION_BY_ID = 'GET_QUOTATION_BY_ID',
    GET_QUOTATION_TEMPLATES = 'GET_QUOTATION_TEMPLATES',
    GENERATE_QUOTATION_PDF = 'GENERATE_QUOTATION_PDF',
    SEND_QUOTATION = 'SEND_QUOTATION',
    UPDATE_QUOTATION_STATUS = 'UPDATE_QUOTATION_STATUS',
}

export interface QuotationError {
    type: QuotationErrorOrigin,
    detail: any
}
